export default function sendClarityEvent(event) {
  if (!event || typeof window.clarity !== "function") return

  window.clarity("event", event)
  window.clarity("upgrade", event)
}
